import React from "react";

function TableLoader({ header = [], isTable = true }) {
  if (isTable) {
    return (
      <tr className="odd:bg-tableodd even:bg-tableeven text-xs 2xl:text-sm font-medium py-1 flex justify-between items-center  my-1">
        {[...Array(header.length || 6)].map((_, index) => {
          return (
            <td
              className={` animate-pulse  ${
                header[index]?.width || "w-[10%]"
              } px-6 py-2`}
              key={index}
            >
              <div className="h-4 w-full rounded-full  bg-gray-200"></div>
            </td>
          );
        })}
      </tr>
    );
  } else {
    return (
      <div className="odd:bg-tableodd even:bg-tableeven text-xs 2xl:text-sm font-medium py-1 flex justify-between items-center  my-1">
        {[...Array(header.length || 6)].map((_, index) => {
          return (
            <div
              className={` animate-pulse  ${
                header[index]?.width || "w-[10%]"
              } px-6 py-2`}
              key={index}
            >
              <div className="h-4 w-full rounded-full  bg-gray-200"></div>
            </div>
          );
        })}
      </div>
    );
  }
}

export default TableLoader;
